import React, { useState, useContext } from "react";
import "./productcard.css";
import Button from "../button/Button";
import { CartContext } from "../../contexts/CartContext";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import { ENDPOINT, getJWT, getOutletSessionId } from "../../helpers/Helper";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { FavouriteContext } from "../../contexts/FavouriteContext";

// const productModal = data => {
//     const price = data.price
//     return (
//         <div className='product_modal'>
//             <div className="product_img">
//                 <img src={data.imageUrl} alt={data.name} />
//             </div>

//             <div className='product_details'>
//                 <h1>{data.name}</h1>
//                 <p>{data.description}</p>
//                 <h3>{`Ksh ${price && price.toLocaleString()}`}.<small>00</small></h3>
//                 <div className='add_to_cart_btn'>
//                     <Button
//                         content="Add to Cart"
//                         contentColor="white"
//                         borderRadius="all"
//                         buttonColor="main-bg"
//                     />
//                 </div>
//             </div>
//         </div>
//     )
// }

const renderLoadingButton = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <Spinner animation="border" variant="light" />
  </div>
);

function ProductCard({ product }) {
  const { products, triggerReload } = useContext(CartContext);
  const { authState, handleShowAuthModal } = useContext(AuthContext);
  const { triggerFavouritesReload } = useContext(FavouriteContext);

  const [loading, setLoading] = useState(false);
  const [loadingFav, setLoadingFav] = useState(false);
  const [favStatus, setFaveStatus] = useState(false);
  const [count, setCount] = useState(
    product && product.quantity ? product.quantity : 0
  );
  // const [showProductModal, setShowProductModal] = useState(false);

  const productCart =
    products && products.find((p) => p.productId === product._id);
  // console.log(productCart?.quantity);

  // const handleShowProductModal = () => {
  //     setShowProductModal(true);
  // }

  // const handleCloseProductModal = () => {
  //     setShowProductModal(false)
  // }

  const price = product.price;

  const handleAddFav = (e) => {
    e.preventDefault();

    const jwt = getJWT();

    setLoadingFav(true);

    axios
      .post(`${ENDPOINT}/products/${product._id}/bookmark`, "", {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        toast(`${product.name} has been added successfully to your wishlist`, {
          type: "success",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        triggerFavouritesReload();
        setFaveStatus(true);
        setLoadingFav(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoadingFav(false);
      });
  };

  const handleRemoveFav = (e) => {
    e.preventDefault();

    const jwt = getJWT();

    setLoadingFav(true);

    axios
      .post(`${ENDPOINT}/products/${product._id}/unbookmark`, "", {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        toast(
          `${product.name} has been successfully removed from your wishlist`,
          {
            type: "success",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          }
        );
        triggerFavouritesReload();
        setFaveStatus(false);
        setLoadingFav(false);
      })
      .catch((err) => {
        toast(`Oops! ${err.response.data.error}`, {
          type: "error",
          position: "top-right",
          autoClose: "1000",
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setLoadingFav(false);
      });
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    setLoading(true);

    const jwt = getJWT();

    if (authState !== undefined) {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: product._id,
            quantity: ((+productCart && productCart.quantity) || 0) + 1,
          },
          { headers: { Authorization: `Bearer ${jwt}` } }
        )
        .then((res) => {
          toast(`${product.name} has been added to your cart successfully`, {
            type: "success",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          triggerReload();
          setLoading(false);
        })
        .catch((err) => {
          toast(`Oops! ${err.response.data.error}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        });
    } else {
      axios
        .post(
          `${ENDPOINT}/cart`,
          {
            productId: product._id,
            quantity: ((+productCart && productCart.quantity) || 0) + 1,
          },
          { headers: { sessionId: `${getOutletSessionId()}` } }
        )
        .then((res) => {
          toast(`${product.name} has been added to your cart successfully`, {
            type: "success",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
          triggerReload();
          setLoading(false);
        })
        .catch((err) => {
          toast(`Ooop! Something wrong happened. ${err}`, {
            type: "error",
            position: "top-right",
            autoClose: "1000",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        });
    }
  };

  // const handleRemoveProduct = () => {
  //     if (count > 0){
  //         setCount(count - 1)
  //     } else {
  //         setCount(0)
  //     }
  // }

  return (
    <div className="card">
      <div className="imgBx">
        <img src={product.imageUrl} />
      </div>

      {authState !== undefined ? (
        <div
          className={`addFav-btn ${
            favStatus ||
            (product && product.bookmarks && product.bookmarks.length)
              ? "active"
              : ""
          }`}
        >
          {loadingFav ? (
            <i class="bx bx-loader"></i>
          ) : (
            <i
              class={`bx ${
                favStatus ||
                (product && product.bookmarks && product.bookmarks.length)
                  ? "bxs-heart"
                  : "bx-heart"
              }`}
              onClick={
                product && product.bookmarks && product.bookmarks.length
                  ? handleRemoveFav
                  : handleAddFav
              }
            ></i>
          )}
        </div>
      ) : (
        <div className={`addFav-btn`}>
          <i
            class={`bx ${favStatus ? "bxs-heart" : "bx-heart"}`}
            onClick={handleShowAuthModal}
          ></i>
        </div>
      )}

      <div className="contentBx">
        {/* <p>750ml</p> */}
        <h3 className="product_link">{product.name}</h3>

        {/* <Modal 
                    show={showProductModal}
                    onHide={handleCloseProductModal}
                    renderBody={productModal(product)}
                /> */}

        <h2 className="price">
          KShs {price && price.toLocaleString()}.<small>00</small>
        </h2>
        <div className="buyBtn">
          <Button
            content={loading ? renderLoadingButton() : "Add to Cart"}
            contentColor="white"
            onClickHandler={(e) => handleAddProduct(e)}
            borderRadius="all"
            buttonColor="main-bg"
          />

          {/* {
                        count === 0 ? (
                            <Button
                                content="Add to Cart"
                                contentColor='white'
                                onClickHandler={() => {
                                    handleAddProduct();
                                    dispatch({ type: 'ADD_CART', product: {
                                        id: uuid(),
                                        productName: product.productName,
                                        productSize: product.productSize,
                                        productPrice: product.productPrice,
                                        quantity: 1,
                                        productImage: product.productImage
                                    }})
                                    console.log(product.productPrice);
                                }}
                                borderRadius="all"
                                buttonColor='main-bg'
                            />
                        ) : (
                            <React.Fragment>
                                <Button
                                    content="-"
                                    contentColor='black'
                                    contentSize="large"
                                    onClickHandler={handleRemoveProduct}
                                    borderRadius="left"
                                />

                                <p>
                                    <i class='bx bx-cart' ></i> {count}
                                </p>

                                <Button
                                    content="+"
                                    contentColor='black'
                                    contentSize="large"
                                    onClickHandler={handleAddProduct}
                                    borderRadius="right"
                                />
                            </React.Fragment>
                        )
                    } */}
        </div>

        <ToastContainer />
      </div>
    </div>
  );
}

export default ProductCard;
